import { Injectable } from '@angular/core';
import { XDRModel } from '../model/XDRModel';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from './common/configuration.service';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { PaymentModel } from '../model/PaymentModel';


// import moment = require('moment');
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient, private config: ConfigurationService) { }


  LTEGetUsageReport(iAccounbt: number, ICustomer: number, startdate: Date, enddate: Date) {

    var url = `${environment.lteHttpBaseUrl}/api/accounts/${iAccounbt}/xdrs?i_customer=${ICustomer}&startdate=${startdate.toLocaleString()}&enddate=${enddate.toLocaleString()}`;
    return this.http.get<any>(url);

  }
  LTEGetUsageReportWithDateString(iAccounbt: number, ICustomer: number, startdate: string, enddate: string) {

    var url = `${environment.lteHttpBaseUrl}/api/accounts/${iAccounbt}/xdrs?i_customer=${ICustomer}&startdate=${startdate}&enddate=${enddate}`;
    return this.http.get<any>(url);

  }

  GetCustomerPayments(ICustomer: string, startdate: Date, enddate: Date) {

    var url = `${environment.lteHttpBaseUrl}/api/payment/customer/${ICustomer}?startdate=${startdate}&enddate=${enddate}`;
    return this.http.get<any>(url);

  }

  GetCustomerAllocations(ICustomer: string, startdate: Date, enddate: Date) {
    var url = `${environment.lteHttpBaseUrl}/api/payment/customer/${ICustomer}/allocations?startdate=${startdate}&enddate=${enddate}`;
    return this.http.get<any>(url);
  }


  GetAccountPayments(IAccount: string, startdate: Date, enddate: Date) {
    var url = `${environment.lteHttpBaseUrl}/api/payment/account/${IAccount}?startdate=${startdate}&enddate=${enddate}`;
    return this.http.get<any>(url);
  }




  GetAccountAllocations(IAccount: string, startdate: Date, enddate: Date) {
    var url = `${environment.lteHttpBaseUrl}/api/payment/account/${IAccount}/allocations?startdate=${startdate}&enddate=${enddate}`;
    return this.http.get<any>(url);
  }

  GetMapCoverage(lat : number , long : number) {
    var url = `${environment.lteHttpBaseUrl}/api/coveragemap/check`;
    var model = {Latitude : lat, Longitude: long};
    return this.http.post<any>(url, model);
  }



}
